import { h } from '@stencil/core';

const BackIcon = () => {
    return (
        <svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.625 12.1421L5.25 12.1421M5.25 12.1421L10.9716 18.1421M5.25 12.1421L10.9716 6.14213" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.0625 6.14214L3.0625 18.1421" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}

export default BackIcon;
